<template>
  <div>
    <div style="padding:5px 0">
      <el-form :disabled="!isEdit" inline label-width="0">
        <el-form-item>
          <div style="display: inline-block;width: 105px;padding-left: 10px;">
            <span :title="$t('SeaExport.DateOfDeparture')">{{ getItemTitle('ETD') }}</span>
          </div>
          <el-date-picker
            v-model="cargoDoc.etd"
            no="10"
            type="date"
            style="width:200px"
            format="yyyy-MM-dd"
            :class="isDifferent('etd')"
          />
        </el-form-item>
        <el-form-item>
          <div style="display: inline-block;width: 105px;padding-left: 10px;">
            <span :title="$t('SeaExport.AMSNumber')">{{ getItemTitle('AMS NO') }}</span>
          </div>
          <el-input v-model="cargoDoc.hblNbr2" no="11" style="width:200px" :class="isDifferent('hblNbr2')" />
        </el-form-item>
        <el-form-item>
          <div style="display: inline-block;width: 105px;padding-left: 10px;">
            <span style="color: #0000FF;" title="MBL号码">{{ getItemTitle('MB/L NO') }}</span>
          </div>
          <el-input v-model="cargoDoc.mbl" no="12" style="width:200px" :class="isDifferent('mbl')" />
        </el-form-item>
        <el-form-item>
          <div style="display: inline-block;width: 105px;padding-left: 10px;">
            <span :title="$t('SeaExport.BillOfLadingType')">{{ getItemTitle('B/L Type') }}</span>
          </div>
          <el-select v-model="cargoDoc.amsBlType" no="13" :disabled="!isEdit" style="width:200px" :class="isDifferent('amsBlType')">
            <el-option
              v-for="item in AmsBLType"
              :key="item.code"
              :label="item.name"
              :value="item.code"
            />
          </el-select>
        </el-form-item>
        <br>
        <el-form-item>
          <div style="display: inline-block;width: 105px;padding-left: 10px;">
            <span :title="$t('SeaExport.ArrivalDate')">{{ getItemTitle('ETA') }}</span>
          </div>
          <el-date-picker v-model="cargoDoc.eta" no="14" type="date" value-format="yyyy-MM-dd" style="width:200px" :class="isDifferent('eta')" />
        </el-form-item>
        <el-form-item>
          <div style="display: inline-block;width: 105px;padding-left: 10px;">
            <span :title="$t('SeaExport.ShippingType')">{{ getItemTitle('Shipment Type') }}</span>
          </div>
          <el-select v-model="cargoDoc.shipmentTypeCode" no="15" :disabled="!isEdit" style="width:200px" :class="isDifferent('shipmentTypeCode')">
            <el-option
              v-for="item in ShipmentTypeCode"
              :key="item.code"
              :label="item.name"
              :value="item.code"
            />
          </el-select>
        </el-form-item>
        <el-form-item>
          <div style="display: inline-block;width: 105px;padding-left: 10px;">
            <span :title="$t('SeaExport.CountryOfOrigin')">{{ getItemTitle('County Of Origin') }}</span>
          </div>
          <el-input v-model="cargoDoc.countryOrigin" style="width:200px" :class="isDifferent('countryOrigin')" />
        </el-form-item>
        <el-form-item>
          <div style="display: inline-block;width: 105px;padding-left: 10px;">
            <span :title="$t('SeaExport.HtsCode')">{{ getItemTitle('Hts Code') }}</span>
          </div>
          <el-input v-model="cargoDoc.hsCode" style="width:200px" :class="isDifferent('hsCode')" />
        </el-form-item>
        <br>
        <el-form-item>
          <div style="display: flex">
            <div style="display: inline-block;width: 105px;padding-left: 10px;">
              <span :title="$t('SeaExport.DischargingPort')">{{ getItemTitle('POD') }}</span>
            </div>
            <cargo-advance-select
              filterable
              :select-type="TYPE_NAMES.basic_data_Seaport"
              style="width:200px"
              :default-value="cargoDoc.dischargingPortCode"
              :class="isDifferent('dischargingPortCode')"
              @parentCallBack="p=>{podPortChange(p, 'dischargingPortCode', 'dischargingPort')}"
            />
          </div>
          <el-input v-model="cargoDoc.dischargingPort" style="width:200px; margin-left: 105px" :class="isDifferent('dischargingPort')" />
        </el-form-item>
        <el-form-item>
          <div style="display: flex">
            <div style="display: inline-block;width: 105px;">
              <span :title="$t('SeaExport.DeliveryPlace')">{{ getItemTitle('Place Of Delivery') }}</span>
            </div>
            <cargo-advance-select
              filterable
              :select-type="TYPE_NAMES.basic_data_Seaport"
              style="width:200px"
              :default-value="cargoDoc.destinationPortCode"
              :class="isDifferent('destinationPortCode')"
              @parentCallBack="p=>{portChange(p, 'destinationPortCode', 'destinationPort')}"
            />
          </div>
          <el-input v-model="cargoDoc.destinationPort" style="width:200px; margin-left: 105px" :class="isDifferent('destinationPortCode')" />
        </el-form-item>
      </el-form>
    </div>
    <div class="section" style="height: 540px">
      <span class="title" :title="$t('SeaExport.CustomerShippingInformation')">{{ getItemTitle('Customer Delivery Info') }}</span>
      <div style="display:flex;flex-direction:column">
        <el-tabs
          v-model="activeTabName"
          type="card"
          style="width: 100%;"
        >
          <el-tab-pane name="tabBookingParty" :label="getItemTitle('Booking party')" :title="$t('SeaExport.OriginalBookingParty')">
            <tab-customer ref="tabBookingParty" party-type="BKP" :isf-type="isfType" :job="job" :cargo-doc="cargoDoc" :is-edit="isEdit" :party-name-list="partyNameList" />
          </el-tab-pane>
          <el-tab-pane name="tabShipToParty" :label="getItemTitle('Container ShipTo Party')" :title="$t('SeaExport.CargoReceiver')">
            <tab-customer ref="tabShipToParty" party-type="ST" :isf-type="isfType" :job="job" :cargo-doc="cargoDoc" :is-edit="isEdit" :party-name-list="partyNameList" />
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import tabCustomer from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabCustomer'
import * as ShipmentTypeCode from '@/class/cargo/model/parameters/ShipmentTypeCode'
import * as AmsBLType from '@/class/cargo/model/parameters/AmsBLType'
import { Company } from '@/class/model/mdm/Company'
import StrUtils from '@/utils/StrUtils'
import * as seaportApi from '@/api/seaport'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { cache, cacheName } from '@/utils/cacheManager'
import ColumnUtils from '@/utils/ColumnUtils'

export default {
  name: 'TabISF05',
  components: { CargoAdvanceSelect, tabCustomer },
  props: {
    job: { type: Object, default: null },
    cargoDoc: { type: Object, default: null },
    isfType: { type: Number, default: null },
    isEdit: { type: Boolean, default: false },
    localData: { type: Object, default: () => {} },
    partyNameList: { type: Array, required: true }
  },
  data() {
    return {
      TYPE_NAMES,
      activeTabName: 'tabBookingParty', // 所选页签名称
      AMSScac: '', // 船公司SCAC
      placeOfDeliveryCountry: '', // 交货地国家
      portList: [], // 港口列表
      ShipmentTypeCode: ShipmentTypeCode.Shipment_Type_Code,
      AmsBLType: AmsBLType.Ams_BL_Type,
      isChineseLanguage: false
    }
  },
  watch: {
    activeTabName(newVal, oldVal) {
      // 若新页签不存在或新页签列表无数据时，执行页签的onShow方法
      const tabRef = this.$refs[newVal]
      if (tabRef && (!tabRef.rowData || tabRef.rowData.length === 0)) {
        tabRef.onShow(true)
      }
    },
    cargoDoc(newVal) {
      if (newVal) {
        this.tabOnShow()
        setTimeout(() => {
          this.$refs[this.activeTabName].onShow(true)
        }, 1000)
      }
    }
  },
  async created() {
    await cache.load(cacheName.CONFIG)
    this.isChineseLanguage = Number(cache.config.get('AntiTerrorismShippingAfrLanguageSwitching')) === 1
  },
  mounted() {
    this.$refs[this.activeTabName].onShow(true)
  },
  methods: {
    onShow(isRefresh) {
      this.loadDataHandler()
      if (isRefresh) {
        this.$refs[this.activeTabName].onShow(isRefresh)
      }
    },
    async loadDataHandler() {
      if (this.cargoDoc) {
        // load AMSSCAC
        const carrierId = this.job.carrierId
        const company = await Company.getCompanyById(carrierId)
        this.AMSScac = company ? company.scac : ''

        // load placeOfDeliveryCountry
        const params = {}
        params.likeName = this.cargoDoc.dischargingPort
        params.tenantId = this.$store.getters.tenantId
        seaportApi.loadAllSeaPort(params).then(resp => {
          this.loadAllSeaPortHandler(resp)
        })
        this.$refs[this.activeTabName].onShow()
      }
    },
    loadAllSeaPortHandler(resp) {
      this.portList = resp.data
      this.placeOfDeliveryCountry = 'CA'
      if (this.portList) {
        const seaport = this.portList[0]
        if (seaport && seaport.countryCode) {
          this.placeOfDeliveryCountry = seaport.countryCode
        }
      }
    },
    tabOnShow() {
      const tabBookingParty = this.$refs['tabBookingParty']
      if (tabBookingParty) {
        tabBookingParty.onShow()
      }
      const tabShipToParty = this.$refs['tabShipToParty']
      if (tabShipToParty) {
        tabShipToParty.onShow()
      }
    },
    portChange(p, portCodeField, portNameField) {
      const form = this.cargoDoc
      form[portCodeField] = p.value
      form[portNameField] = p.englishName
    },
    podPortChange(p, portCodeField, portNameField) {
      const form = this.cargoDoc
      form[portCodeField] = p.value
      form[portNameField] = p.englishName
    },
    fillModel() {
      const allList = []
      const tabBookingParty = this.$refs['tabBookingParty']
      if (tabBookingParty) {
        const tabBookingPartyList = tabBookingParty.getTabRowData()
        allList.push(...tabBookingPartyList)
      } else {
        for (const tabIsfData of this.cargoDoc.isfPassenger) {
          if (tabIsfData.isfType === 5 && tabIsfData.partyType === 'BKP') {
            allList.push(tabIsfData)
          }
        }
      }
      const tabShipToParty = this.$refs['tabShipToParty']
      if (tabShipToParty) {
        const tabShipToPartyList = tabShipToParty.getTabRowData()
        allList.push(...tabShipToPartyList)
      } else {
        for (const tabIsfData of this.cargoDoc.isfPassenger) {
          if (tabIsfData.isfType === 5 && tabIsfData.partyType === 'ST') {
            allList.push(tabIsfData)
          }
        }
      }
      if (this.cargoDoc.isfPassenger) {
        for (const isf of this.cargoDoc.isfPassenger) {
          if (isf.isfType === 10) {
            allList.push(isf)
          }
          if (isf.isfType === 5 && isf.opType === 'del') {
            allList.push(isf)
          }
        }
      }
      this.cargoDoc.isfPassenger = allList
    },
    getItemTitle(targetCode) {
      if (this.isChineseLanguage) {
        return ColumnUtils.afrLabelFunc(targetCode)
      }
      return targetCode
    },
    isDifferent(field) {
      return this.localData.importDifferentField && this.localData.importDifferentField.hasOwnProperty(field) ? 'warning' : ''
    }
  }
}
</script>

<style scoped>

</style>
